import { useSyncExternalStore } from 'react';

// ── Books shown in the Markets modal ──
// One list for every page that opens the modal, so the columns don't change
// depending on where you clicked from. Persisted to localStorage. An empty
// list means "every book in the snapshot".
export const MARKETS_BOOKS_KEY = 'sharpstackMarketsBooks';

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(MARKETS_BOOKS_KEY) || '[]');
    return Array.isArray(v) ? v.filter((b) => typeof b === 'string') : [];
  } catch (e) { return []; }
};

let current = read();
const listeners = new Set();
const notify = () => listeners.forEach((l) => { try { l(); } catch (e) { /* ignore */ } });

export const getMarketsBooks = () => current;

export const setMarketsBooks = (books) => {
  const next = Array.isArray(books) ? [...new Set(books)] : [];
  if (next.length === current.length && next.every((b, i) => b === current[i])) return;
  current = next;
  try { localStorage.setItem(MARKETS_BOOKS_KEY, JSON.stringify(next)); } catch (e) { /* storage may be blocked */ }
  notify();
};

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

// Cross-tab sync
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === MARKETS_BOOKS_KEY) { current = read(); notify(); }
  });
}

export const useMarketsBooks = () => useSyncExternalStore(subscribe, getMarketsBooks, getMarketsBooks);
